var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"stand-out-btn wf-dela-gothic-one-regular",class:_vm.$mq,on:{"click":_vm.onClickEvent}},[_c('span',[_c('move-text-hover',{attrs:{"target-text":_vm.msg}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }